<script>
import axios from 'axios';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        loginInfo: { required: true },
      },
      formData: {
        loginInfo: '',
      },
    };
  },
  created() {

  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    submit() {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return axios.post('/api/resetPassword', this.formData)
        .then(() => {
          this.showSuccessMessage('Ihr Passwort wurde zurückgesetzt. Eine Email mit Ihrem neuen Passwort wurde an Sie versendet.');
        })
        .catch(({ response }) => {
          let errorMessage;

          if (response.data && response.data.data && response.data.data.error) {
            errorMessage = response.data.data.error;
          }

          this.showErrorMessage(errorMessage);
        })
        .finally(() => {
          this.isLoading = false;
          this.close();
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="800px">

    <v-card>
      <v-card-title class="title pa-3">
        Passwort zurücksetzen
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex xs12 md12 py-0>
              Bitte geben Sie Ihre Email-Adresse ein, um Ihr Passwort zurückzusetzen.
              Sie erhalten eine Email mit Ihrem neuen Passwort.
            </v-flex>
            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.loginInfo"
                :error-messages="validationErrorMessages.loginInfo"
                label="Email-Adresse oder Nutzername"
                height="22"
                class="caption"
              />
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="grey"
               dark>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               dark>
          OK
        </v-btn>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
